import ModalComponent from '../../../../components/ModalComponent';
import { useContext } from 'react';
import { AlarmCentralPhysicalContext } from '../../context/AlarmCentralPhysicalContext';
import { Box } from '@mui/material';

interface AlarmCentralProblemsDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const AlarmCentralProblemsDialog = ({
  isOpen,
  onClose,
}: AlarmCentralProblemsDialogProps) => {
  const { alarmCentral, problems } = useContext(AlarmCentralPhysicalContext);

  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={onClose}
      title={'Problemas referentes à central ' + alarmCentral?.name}
    >
      {problems &&
        problems.length > 0 &&
        problems.map((p, i) => (
          <Box
            key={i}
            sx={{ mb: 0.5, display: 'flex', alignItems: 'center', gap: 1 }}
          >
            <Box sx={{ width: 15, height: 15, backgroundColor: 'red' }}></Box>
            {p.description}
          </Box>
        ))}
    </ModalComponent>
  );
};

export default AlarmCentralProblemsDialog;
